import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { IModulesPage } from "./types";

const ModulesPage = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [modulo, setModulo] = useState([]);
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");

    fetch("https://has-backend-c48d669d897f.herokuapp.com/admin/modules", {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) throw new Error(`Error HTTP! Estado: ${response.status}`);
        return response.json();
      })
      .then((data) => {
        const sortedModules = data.sort((a: { week: number }, b: { week: number }) => a.week - b.week);
        setModulo(sortedModules);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error al cargar modulos:", error);
        setIsLoading(false);
      });
  }, []);

  return (
    <div className="min-h-screen w-full px-4 sm:px-8">
      <div className="flex flex-col items-start gap-4 mt-12">
        <h2 className="font-playfair font-bold text-3xl sm:text-4xl">Todos los módulos</h2>
        <div className="w-full flex flex-col">
          <div className="hidden sm:flex flex-row justify-between px-12 pb-4">
            <p className="font-bold font-sourceSans">Módulo</p>
            <p className="font-bold font-sourceSans">Semana</p>
          </div>

          {isLoading ? (
            <p>Cargando módulos...</p>
          ) : modulo.length > 0 ? (
            modulo.map((mod: IModulesPage) => (
              <div
                key={mod.week}
                className="flex flex-col sm:flex-row justify-between border-y border-gray-600 py-2 px-4 sm:px-12 text-sm sm:text-base"
              >
                <a
                  onClick={() => navigate(`/admin/modules/${mod._id}`)}
                  className="text-[#2755ee] font-sourceSans cursor-pointer"
                >
                  {mod.title}
                </a>
                <p className="font-sourceSans sm:text-right mt-1 sm:mt-0">Semana {mod.week}</p>
              </div>
            ))
          ) : (
            <p>No hay módulos disponibles.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ModulesPage;
